import { all, put, takeEvery } from "redux-saga/effects";
import {
  fetchUnreadCount,
  readAllNotifications,
  updateNotification
} from "../../Services/database";
import { setErrorStatus, setSuccessStatus } from "../status/action";
import store from "../store";
import { updateUnreadCount } from "./actions";

export const notificationActions = {
  SET_NOTIFICATION: "SET_NOTIFICATION",
  UPDATE_NOTIFICATION: "UPDATE_NOTIFICATION",
  LOAD_MORE_NOTIFICATIONS: "LOAD_MORE_NOTIFICATIONS",
  SET_UNREAD_NOTIFICATION_COUNT: "SET_UNREAD_NOTIFICATION_COUNT",
  PATCH_NOTIFICATION: "PATCH_NOTIFICATION"
};

function* putNotificationsWorker(action) {
  updateUnreadCount();

  yield put({
    type: "PUT_NOTIFICATION",
    payload: action.payload
  });
}

function* updateNotificationWorker(action) {
  try {
    let updates = {};

    switch (action.payload.updateType) {
      case "ARCHIVE":
        updates = { archived: true, read: true };
        break;
      case "UNARCHIVE":
        updates = { archived: false };
        break;
      case "READ":
        updates = { read: true };
        break;
      case "UNREAD":
        updates = { read: false };
        break;
      case "READ_ALL":
        const status = yield readAllNotifications(
          store.getState().auth.data.uid
        );
        if (status.success) {
          yield setSuccessStatus("All notifications marked as read.");
          updateUnreadCount();
        } else {
          yield setErrorStatus({
            code: "custom",
            message: "Failed to mark all notifications as read."
          });
        }
        return;
      default:
        return;
    }
    const status = yield updateNotification(
      action.payload.ruleId,
      action.payload.documentId,
      updates
    );
    if (status.success) {
      const updatedNotifications = patchNotification(
        action.payload.documentId,
        updates
      );

      yield put({
        type: "PUT_NOTIFICATION",
        payload: updatedNotifications
      });

      updateUnreadCount();
    } else {
      yield setErrorStatus({
        code: "custom",
        message: "Failed to update notification."
      });
    }
  } catch (error) {
    setErrorStatus(error);
    console.error("error from update notification", error);
  }
}

function* loadMoreNotificationsWorker(action) {
  yield put({
    type: "PUT_MORE_NOTIFICATION",
    payload: action.payload
  });
}

function* updateUnreadNotificationCountWorker() {
  try {
    const count = yield fetchUnreadCount(store.getState().auth.data.uid);
    yield put({
      type: "PUT_UNREAD_NOTIFICATION_COUNT",
      payload: count
    });
  } catch (error) {
    setErrorStatus(error);
    console.error("error from update notification count", error);
  }
}

export default function* notificationsWatcher() {
  yield all([
    takeEvery("SET_NOTIFICATION", putNotificationsWorker),
    takeEvery("UPDATE_NOTIFICATION", updateNotificationWorker),
    takeEvery("LOAD_MORE_NOTIFICATIONS", loadMoreNotificationsWorker),
    takeEvery(
      "SET_UNREAD_NOTIFICATION_COUNT",
      updateUnreadNotificationCountWorker
    )
  ]);
}

const patchNotification = (documentId, data) => {
  const state = store.getState().notifications;
  const moveNotification = (from, to) => {
    const notification = state[from][documentId];
    if (!notification) return state;

    const updated = { ...notification, ...data };
    const newState = { ...state };

    newState[from] = { ...state[from] };
    delete newState[from][documentId];

    newState[to] = {
      ...state[to],
      [documentId]: updated
    };

    return newState;
  };
  if (data.archived === true) {
    return moveNotification("inbox", "archived");
  }

  if (data.archived === false) {
    return moveNotification("archived", "inbox");
  }
  return {
    ...state,
    inbox: state.inbox[documentId]
      ? {
          ...state.inbox,
          [documentId]: { ...state.inbox[documentId], ...data }
        }
      : state.inbox,
    archived: state.archived[documentId]
      ? {
          ...state.archived,
          [documentId]: { ...state.archived[documentId], ...data }
        }
      : state.archived
  };
};
